module.exports = "/images/place.svg?f431f3019d23a19dd3c32399fe75b645";